<template>
    <div class="items-search" :class="{club: isClub}">
        <p class="title">{{ title }}</p>
        <div class="item" v-for="(term, index) in terms" :key="index" @click="$emit('termClicked', term)">
            <i v-if="isClub" :class="icon" />
            {{ term }} 
            <i v-if="!isClub" :class="icon" />
        </div>
    </div>
</template>
<script>
export default {
    name: "TermsList",
    props: {
        terms: {
            type: Array,
            default: null,
        },
        title:{
            type: String,
            default: ''
        },
        icon:{
            type: String,
            default: 'prz-search'
        },
        isClub:{
            type: Boolean,
            default: true
        }
    },
    // data() {
    //     return {};
    // },
    // mounted() {
    //     console.log(this.termsRecentlySearched,'termsRecentlySearched');
    // },
    // computed: {},
    // methods: {},
};
</script>
<style lang="scss">

</style>